import { useCallback, useRef, useState } from 'react';
import { Animated, Easing, Platform } from 'react-native';

export function useFadeInAnimation(fadedInCallback?: () => void) {
	const [isFadeInFinished, toggleFadeInFinished] = useState(false);
	const animatedOpacityValue = useRef(new Animated.Value(0)).current;

	const startFadeIn = useCallback(() => {
		if (!isFadeInFinished) {
			Animated.timing(animatedOpacityValue, {
				toValue: 1,
				delay: 0,
				isInteraction: false,
				useNativeDriver: Platform.OS !== 'web',
				duration: 100,
				easing: Easing.in(Easing.ease),
			}).start(() => {
				toggleFadeInFinished(true);
				if (typeof fadedInCallback === 'function') {
					fadedInCallback();
				}
			});
		}
	}, [isFadeInFinished, animatedOpacityValue, fadedInCallback]);

	return {
		fadedIn: isFadeInFinished,
		opacity: animatedOpacityValue,
		startFadeIn,
	};
}
